import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";

const TablaHistoricoRentas = (props) => {
  const [records, setRecords] = useState([]);

  const headCells = [
    {
      id: "anio",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-alt">
          {" "}
          AÑO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "mes",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          MES
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "monto",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill">
          {" "}
          MONTO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "interes",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i
          style={{ textAlign: "center" }}
          className="fas fa-money-bill-wave-alt"
        >
          {" "}
          INTERES MORA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "recargo",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-check">
          {" "}
          RECARGOS{" "}
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "recibo",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-file-invoice">
          {" "}
          NRO.RECIBO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "fechapago",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-day">
          {" "}
          FECHA DE PAGO
        </i>
      ),
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, TblPagination } = useTableFijo(
    records,
    headCells,
    {
      fn: (items) => {
        return items;
      },
    },
    280
  );

  useEffect(() => {
    if (props.tabpago) {
      setRecords(props.tabpago);
    }
  }, [props.tabpago]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.anio}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.mes}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.intereses.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.recargo.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.recibo === null ? "" : item.recibo.trim()}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechapago).format("DD/MM/YYYY")}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaHistoricoRentas;



// WEBPACK FOOTER //
// ./src/components/rentas/historicoDeudaRentas.js